import { castToBoolean } from '../../../../../lib/util';

class DashboardNotificationsController {
  constructor(
    $q,
    $scope,
    $sce,
    $translate,
    LogService,
    APIService
  ) {
    "ngInject";
    this.$q = $q;
    this.$scope = $scope;
    this.$sce = $sce;
    this.$translate = $translate;
    this.LogService = LogService;
    this.APIService = APIService;
  }

  $onInit() {
    this._updateNotifications(this._notifications);
  }

  set staffUser(u) {
    this._staffUser = u;
  }

  get staffUser() {
    return this._staffUser;
  }

  set notifications(notifications) {
    this._notifications = notifications;
    this._updateNotifications(notifications);
  }

  get notifications() {
    return this._notifications;
  }

  get dismissableNotifications() {
    return this._dismissableNotifications;
  }

  get permanentNotifications() {
    return this._permanentNotifications;
  }

  _updateNotifications(notifications) {
    const dismissable = [];
    const permanent = [];

    notifications = notifications || this._notifications || [];
    notifications.forEach(notification => {
      if (!!notification.dismissable) {
        dismissable.push(notification);
      } else {
        permanent.push(notification);
      }
    });
    this._dismissableNotifications = dismissable;
    this._permanentNotifications = permanent;
  }

  getFormattedTextForNotification(notification) {
    /**
     * We need to return synchronously to ng-bind-html, but we also need to do async translations.
     * To work around this, we'll set a new property on the notification, translatedText.
     *
     * If it is not yet set, we'll return a temporary value, then do the translation, then next time we're called
     * we'll return the fully translated value
     */
    if (notification.translatedText) {
      const text = notification.translatedText;
      return this.$sce.getTrustedHtml(text);
    } else {
      if (notification.translationKey) {
        // Kick off the translation, then store in notification.translatedText; immediately return the .text property
        const translationPromise = this.$translate(notification.translationKey, notification.values)
          .then(translated => {
            notification.translatedText = translated;
            return notification;
          });
      }
      return notification.text;
    }
  }

  getCssClassessForNotification(notification) {
    if (notification.cssClass) {
      return 'alert ' + notification.cssClass;
    } else {
      return 'alert alert-info';
    }
  }

  isNotificationVisible(notification) {
    return notification && !notification.dismissedAt
  }

  dismissNotification(notification, index) {
    notification.dismissedAt = new Date();
    if (this.onDismissNotification) {
      this.onDismissNotification({
        notification,
      })
    }
  }

  notificationClicked(notification) {
    this.LogService.info(`DashboardNotificationsController.notificationClicked()`, notification);
    if (notification.onClick) {
      notification.onClick(notification);
    }
  }
}

export default DashboardNotificationsController;
